export default "__VITE_ASSET__444dadcc__"